exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".welcome-header .header-left img[data-v-1ea8f851] {\n  max-width: 220px;\n  height: auto;\n}\n.welcome-header .header-right[data-v-1ea8f851] {\n  float: right;\n  font-size: 16px;\n  color: white;\n  text-transform: uppercase;\n}\n", ""]);

// exports
